import clsx from 'clsx'
import React from 'react'
import { Dialog, OverlayArrow, Popover as AriaPopover } from 'react-aria-components'

import type { IProps } from './interfaces'
import styles from './styles.module.scss'

const WIDTH_CLASSES: Record<NonNullable<IProps['width']>, string | undefined> = {
  sm: styles.widthSm,
  md: styles.widthMd,
  trigger: styles.widthTrigger,
}

/**
 * The kit's popover surface (DS menu): the card ground with a hairline, lifted with the menu shadow.
 * Put it in a react-aria `DialogTrigger` after a kit `Button`, or control it with `isOpen` and
 * `triggerRef`. The content is a dialog unless it brings its own role (`isDialog={false}`).
 */
export const Popover = ({
  children,
  isDialog = true,
  'aria-label': ariaLabel,
  placement = 'bottom start',
  showArrow = false,
  width = 'md',
  isOpen,
  onOpenChange,
  triggerRef,
  isNonModal,
  className,
  'data-testid': testId,
}: IProps): React.JSX.Element => (
  <AriaPopover
    className={clsx(styles.popover, WIDTH_CLASSES[width], className)}
    placement={placement}
    offset={showArrow ? 10 : 6}
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    triggerRef={triggerRef}
    isNonModal={isNonModal}
    data-testid={testId}
  >
    {showArrow && (
      <OverlayArrow className={styles.arrow}>
        <svg width={12} height={12} viewBox="0 0 12 12" aria-hidden="true">
          <path d="M0 0 L6 6 L12 0" />
        </svg>
      </OverlayArrow>
    )}
    {isDialog ? (
      <Dialog className={styles.dialog} aria-label={ariaLabel}>
        {children}
      </Dialog>
    ) : (
      children
    )}
  </AriaPopover>
)
